/**
 * 数学计算工具 — 基于 big.js 精确浮点数运算
 *
 * JS 经典问题：0.1 + 0.2 !== 0.3
 * big.js 通过内部整数表示精确计算，无精度丢失
 *
 * 使用示例：
 *   ttx.math.add(0.1, 0.2)      // 0.3
 *   ttx.math.sub(1.0, 0.9)      // 0.1
 *   ttx.math.mul(1.01, 2.5)     // 2.525
 *   ttx.math.div(0.3, 0.1)      // 3
 *   ttx.math.round(1.235, 2)    // 1.24
 */
import Big from 'big.js';

window.ttx = window.ttx || {};
ttx.math = ttx.math || {};

(function () {
    /**
     * 精确加法
     * @param {number} a
     * @param {number} b
     * @returns {number}
     */
    ttx.math.add = function (a, b) {
        return Big(a).plus(b).toNumber();
    };

    /**
     * 精确减法
     * @param {number} a
     * @param {number} b
     * @returns {number}
     */
    ttx.math.sub = function (a, b) {
        return Big(a).minus(b).toNumber();
    };

    /**
     * 精确乘法
     * @param {number} a
     * @param {number} b
     * @returns {number}
     */
    ttx.math.mul = function (a, b) {
        return Big(a).times(b).toNumber();
    };

    /**
     * 精确除法
     * @param {number} a
     * @param {number} b
     * @returns {number}
     */
    ttx.math.div = function (a, b) {
        return Big(a).div(b).toNumber();
    };

    /**
     * 精确四舍五入
     * @param {number} num
     * @param {number} decimals - 保留小数位数，默认 2
     * @returns {number}
     */
    ttx.math.round = function (num, decimals) {
        return Big(num).round(decimals || 2).toNumber();
    };
})();
